module.exports = __webpack_public_path__ + "media/svg/np-f6d8de21.svg";